module.exports = __webpack_public_path__ + "img/t1-x2.78496a27.svg";